import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const helmetContext = {};

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 2, // 2 min pour toutes les queries
            gcTime: 1000 * 60 * 10,
            retry: 1, // 1 seule tentative en cas d'erreur (défaut: 3)
            refetchOnWindowFocus: true, // refetch au focus de la fenêtre
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HelmetProvider context={helmetContext}>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </HelmetProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
